export const CHANGE_LOCATION = "CHANGE_LOCATION_LANDING";
export const CHANGE_CHECKIN = "CHANGE_CHECKIN_LANDING";
export const CHANGE_CHECKOUT = "CHANGE_CHECKOUT_LANDING";

